module.exports = __webpack_public_path__ + "img/logo.73e3e318.png";